export default __webpack_public_path__ + "static/media/IMG-20230716-WA0052 - Ani Dubey.6255b9ba.jpg";